import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  ShoppingCart, UtensilsCrossed, Store, Truck, Package 
} from 'lucide-react';

/**
 * POSTabNavigation - Tab navigation for mobile/tablet POS
 * Replaces the sidebar with tabs for different views
 */
export default function POSTabNavigation({
  activeTab,
  onTabChange,
  orderCounts = {}
}) {
  const tabs = [
    { 
      id: 'pos', 
      label: 'Verkauf', 
      shortLabel: 'Verkauf',
      icon: ShoppingCart, 
      color: 'teal',
      count: null 
    },
    { 
      id: 'tables', 
      label: 'Tische', 
      shortLabel: 'Tische',
      icon: UtensilsCrossed, 
      color: 'purple',
      count: orderCounts.tables 
    },
    { 
      id: 'pickup', 
      label: 'Abholer', 
      shortLabel: 'Abholen',
      icon: Store, 
      color: 'emerald',
      count: orderCounts.pickup 
    },
    { 
      id: 'delivery', 
      label: 'Lieferung', 
      shortLabel: 'Liefern',
      icon: Truck, 
      color: 'blue',
      count: orderCounts.delivery 
    },
  ];

  const colorClasses = {
    teal: {
      active: 'bg-teal-500 text-white shadow-lg shadow-teal-500/30',
      inactive: 'text-slate-400 hover:text-teal-400 hover:bg-teal-500/10',
      badge: 'bg-teal-400'
    },
    purple: {
      active: 'bg-purple-500 text-white shadow-lg shadow-purple-500/30',
      inactive: 'text-slate-400 hover:text-purple-400 hover:bg-purple-500/10',
      badge: 'bg-purple-400'
    },
    emerald: {
      active: 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/30',
      inactive: 'text-slate-400 hover:text-emerald-400 hover:bg-emerald-500/10',
      badge: 'bg-emerald-400'
    },
    blue: {
      active: 'bg-blue-500 text-white shadow-lg shadow-blue-500/30',
      inactive: 'text-slate-400 hover:text-blue-400 hover:bg-blue-500/10',
      badge: 'bg-blue-400'
    },
  };

  return (
    <div 
      className="flex-shrink-0 p-2 bg-[#0B1220]/90 backdrop-blur-sm border-b border-slate-700/50 lg:hidden"
      data-testid="pos-tab-navigation"
    >
      <div className="flex gap-1.5">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const colors = colorClasses[tab.color];
          
          return (
            <Button
              key={tab.id}
              size="sm"
              variant={isActive ? 'default' : 'ghost'}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex-1 h-12 relative transition-all duration-200
                ${isActive ? colors.active : colors.inactive}
              `}
              data-testid={`pos-tab-${tab.id}`}
            >
              <div className="flex flex-col items-center gap-0.5">
                <div className="relative">
                  <Icon size={18} />
                  {tab.count > 0 && (
                    <span 
                      className={`
                        absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1
                        ${colors.badge} text-white text-[10px] font-bold 
                        rounded-full flex items-center justify-center
                        ${!isActive && 'animate-pulse'}
                      `}
                    >
                      {tab.count > 9 ? '9+' : tab.count}
                    </span>
                  )}
                </div>
                <span className="text-[10px] font-medium hidden xs:block">
                  {tab.shortLabel}
                </span>
              </div>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
